module.exports = __webpack_public_path__ + "static/media/ic-bluetooth.e432e33c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-bluetooth.svg
// module id = 601
// module chunks = 14